import createVueComponent from '../createVueComponent';

const Copyright = createVueComponent('CopyrightIcon', [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['path', { d: 'M15 9.354a4 4 0 100 5.292' }],
]);

export default Copyright;
